export class Dragon {
  constructor(sprite = null) {
    this.x = 120;
    this.y = 200;
    this.width = 64;
    this.height = 48;

    // Sprite animation
    this.sprite = sprite;
    this.frameIndex = 0;
    this.frameCount = 4;
    this.frameWidth = 64;
    this.frameHeight = 48;
    this.frameSpeed = 6;
    this.frameTimer = 0;
  }

  move(x, y) {
    // Allow free movement within canvas bounds
    this.x = Math.max(0, Math.min(800 - this.width, x));
    this.y = Math.max(0, Math.min(450 - this.height, y));
  }

  update() {
    if (this.sprite) {
      this.frameTimer++;
      if (this.frameTimer >= this.frameSpeed) {
        this.frameIndex = (this.frameIndex + 1) % this.frameCount;
        this.frameTimer = 0;
      }
    }
  }

  draw(ctx) {
    if (this.sprite && this.sprite.complete) {
      // Draw sprite animation
      ctx.drawImage(
        this.sprite,
        this.frameIndex * this.frameWidth,
        0,
        this.frameWidth,
        this.frameHeight,
        this.x,
        this.y,
        this.width,
        this.height
      );
    } else {
      // Fallback: draw emoji dragon
      ctx.font = '48px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('🐉', this.x + this.width / 2, this.y + this.height / 2);
    }
  }
}

